import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Drafts</h1>
            <div>
              <ol>
                <li>Can be toggled on/off in the account workspace page. </li>
                <li>Adding and editing creates a draft, instead of saving to the orginal.</li>
                <li>Drafts can be saved or discarded at will.</li>
                <li>Drafts can be played back just as any other saved test.    </li>
              </ol>
              <h1>Turning on Drafts</h1>
              <p>Navigate to the account workspace where you'd like to toggle drafts.</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1530673930/Drafts/Screen_Shot_2018-07-03_at_10.10.52_PM.png" style={{width: "400px"}}/></p>
              <p>Now when you create/edit a test it will copy that test as a draft.</p>
              <p>If editing a test, the original won't be touched until you hit "save draft" which will replace the existing one. </p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1530673941/Drafts/Screen_Shot_2018-07-03_at_10.05.44_PM.png" style={{width: "400px"}}/></p>
              <div className="info">Draft playback is seamless.</div>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1530674220/Drafts/draft-playback.gif" style={{width: "400px"}} /></p>
              <p></p>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/drafts.js